"use client";
import React, {useEffect, useRef, useState} from 'react';
import {homeHeroMedia, ORIGINAL_HERO_VIDEO, ORIGINAL_HERO_POSTER} from '../../utils/homeHeroMedia';

export default function HeroMedia({content}) {
  const config = homeHeroMedia(content);
  const player = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [failed, setFailed] = useState(false);
  const [poster, setPoster] = useState(config.poster);
  useEffect(() => {
    setPoster(config.poster);
    if (config.poster === ORIGINAL_HERO_POSTER) return;
    const image = new Image();
    image.onerror = () => setPoster(ORIGINAL_HERO_POSTER);
    image.src = config.poster;
    return () => { image.onerror = null; };
  }, [config.poster]);
  useEffect(() => {
    const video = player.current;
    video.pause();
    video.removeAttribute('src');
    video.load();
    setPlaying(false);
    setFailed(false);
  }, [config.desktop, config.mobile]);
  const toggle = () => {
    if (playing) player.current.pause();
    else {
      // Choose a mobile file only on activation; never preload either video.
      const source = failed ? ORIGINAL_HERO_VIDEO : window.matchMedia('(max-width: 767px)').matches && config.mobile ? config.mobile : config.desktop;
      if (!player.current.getAttribute('src')) player.current.src = source;
      player.current.play()?.catch(() => setPlaying(false));
    }
  };
  const onError = () => {
    setPlaying(false);
    setFailed(true);
    player.current.removeAttribute('src');
    player.current.load();
  };
  // Original-specific crop hides the logo embedded in the original film.
  // A replacement video keeps normal framing and uses the chosen focal point.
  const original = failed || config.desktop.split('?')[0] === ORIGINAL_HERO_VIDEO;
  return <button type="button" className="hero-video-trigger" onClick={toggle}
    aria-label={playing ? 'Sæt baggrundsvideo på pause' : 'Afspil baggrundsvideo om flytning'}>
    <video ref={player} className="hero-video-bg"
      poster={poster} preload="none" muted loop playsInline
      style={{...(original ? {} : {'--hero-crop-top': '0px'}), ...(config.position ? {objectPosition: config.position} : {})}}
      onPlaying={() => setPlaying(true)} onPause={() => setPlaying(false)}
      onError={onError} aria-hidden="true" />
  </button>;
}
